module.exports = "/packs/pattern-left-green-62f49d7c84891d968ca9f461d465002f.png";